module.exports = __webpack_public_path__ + "img/24.b212e652.jpg";